import React, {type ReactElement} from 'react';
import {Text} from 'components/Text';

import {Container, Photo} from './style';
import {NewTabLink} from '../NewTabLink';

type MentionProps = {
  link: UrlString;
  name: string;
  role: string;
  photo: string;
};

export const Mention = ({link, name, role, photo}: MentionProps): ReactElement => {
  return (
    <Container>
      <Photo src={photo} alt={`${name}, портрет.`} />
      <Text>
        <strong>{name}</strong>
      </Text>
      <Text color='grey'>{role}</Text>
      <NewTabLink href={link} aria-label='Перейти на сайт' />
    </Container>
  );
};
